import { RxDocument, RxJsonSchema } from 'rxdb';

import { TCapacityCheckProcessInstance, VehicleType } from '@mopla/data-models';

export type ICapacityCheckDocType<
	ItineraryType extends 'LBODTFLEX' | 'PRODT' | 'ANY'
> = TCapacityCheckProcessInstance<ItineraryType> & {
	id: string; //RxDB document id
	capacityCheckId: string | null; //CapacityCheck instance id (in the BE side)
	mode: 'LBODTFLEX' | 'PRODT';
	vehicleType?: VehicleType;
	/** User accepted current alternative class. Cleared on resume(). */
	alternativeAcknowledged?: boolean;
};

export type TCapacityCheckRxDocument<
	ItineraryType extends 'LBODTFLEX' | 'PRODT' | 'ANY'
> = RxDocument<ICapacityCheckDocType<ItineraryType>>;

export const capacityCheckJSONSchema: RxJsonSchema<
	ICapacityCheckDocType<'ANY'>
> = {
	title: 'capacity check schema',
	version: 2,
	primaryKey: 'id',
	type: 'object',
	properties: {
		id: {
			type: 'string',
			maxLength: 300,
		},
		capacityCheckId: {
			type: 'string',
		},
		mode: {
			type: 'string',
			enum: ['LBODTFLEX', 'PRODT'],
		},
		vehicleType: {
			type: 'string',
			enum: [
				VehicleType.ECONOMY,
				VehicleType.BUSINESS,
				VehicleType.BUSINESS_VAN,
				VehicleType.FIRST_CLASS,
			],
		},
		alternativeAcknowledged: {
			type: 'boolean',
		},
		status: {
			type: 'string',
		},
		requestedParams: {
			type: 'object',
		},
		reservedUntil: {
			type: ['string', 'null'],
		},
		result: {
			type: ['object', 'null'],
			properties: {
				alternativeVehicleType: {
					type: ['boolean', 'null'],
				},
				itinerary: {
					type: 'object',
				},
				reservedUntil: {
					type: ['string', 'null'],
				},
			},
			additionalProperties: true,
		},
		progress: {
			type: ['object', 'null'],
		},
	},
	required: ['id', 'mode'],
};
